import { OutboundDraft, OutboundDraftKind, OutboundDraftStatus } from '../../../api/services/outboundDrafts';

/** Flat tints only — no gradients anywhere on this surface. */
export const KIND_LABELS: Record<OutboundDraftKind, string> = {
  REPAIR_REQUEST: 'Repair request',
  COUNTER_OFFER: 'Counter offer',
  OFFER_SUBMISSION: 'Offer',
  TITLE_INTRO: 'Title intro',
  LENDER_INTRO: 'Lender intro',
  CLOSING_TIME: 'Closing time',
  GENERAL: 'Message',
};

export const STATUS_LABELS: Record<OutboundDraftStatus, string> = {
  DRAFT: 'Needs review',
  APPROVED: 'Approved',
  SENT: 'Sent',
  REJECTED: 'Rejected',
};

export const STATUS_COLORS: Record<OutboundDraftStatus, string> = {
  DRAFT: '#B45309',
  APPROVED: '#0369A1',
  SENT: '#15803D',
  REJECTED: '#B91C1C',
};

/** Drafts still waiting on a decision. This is what the nav badge counts. */
export function pendingCount(drafts: OutboundDraft[]): number {
  return drafts.filter((draft) => draft.status === 'DRAFT' || draft.status === 'APPROVED').length;
}

export function formatTimestamp(value: string | null): string | null {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatDeadline(value: string | null): string | null {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** The one line under the card title that says which deal this is. */
export function contextLine(draft: OutboundDraft): string {
  const parts = [draft.context.address ?? 'No address on file', `To ${draft.context.party}`];
  const deadline = formatDeadline(draft.context.deadline);
  if (deadline) parts.push(`Due ${deadline}`);
  return parts.join(' · ');
}

/**
 * True when Reva queued the draft without a counterparty address. The queue
 * flags these so they are not mistaken for drafts that are ready to send.
 */
export function needsRecipient(draft: OutboundDraft): boolean {
  return !draft.toEmail && draft.status !== 'SENT' && draft.status !== 'REJECTED';
}
